import {Component, OnInit} from '@angular/core'

@Component({
  selector: 'app-rt-progress-bar',
  template: `<span></span>`,
  standalone: false,
})
export class RtProgressBarComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
